import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContratoService } from '../../../base/services/contrato.service';
import { DialogService } from '../../services/dialog.service';
import { ReturnAPI } from 'src/app/base/domain/return-api.model';
import { Contrato } from 'src/app/base/domain/contrato.model';
import { SituacaoContratoDTO } from 'src/app/base/domain/dto/situacao-contrato.dto';
import { SharedService } from 'src/app/auth/shared.service';
import { Usuario } from 'src/app/base/domain/usuario.model';

@Component({
  selector: 'app-alterar-valor-liquido',
  templateUrl: './alterar-valor-liquido.component.html',
  styleUrls: ['./alterar-valor-liquido.component.css'],
})
export class AlterarValorLiquidoComponent implements OnInit {

  contrato: Contrato | null = null;
  valorLiquidoAtual: number | null = null;
  valorLiquido: number | null = null;
  situacaoContratoSelecionada: number | null = null;
  dataEmissao: Date | null = null;
  dataLiberacao: Date | null = null;
  dataAlteracao: Date | null = null;
  dataFinalizacao: Date | null = null;
  dataVencimento: Date | null = null;
  dataVencimentoDiasCorridos: Date | null = null;
  carregando: boolean = true;
  nomeFuncionario: string | null = null;
  situacoesContrato: { label: string; value: number; nomeEnum: string }[] = [];
  shared: SharedService;
  usuario: Usuario | null = null;
  constructor(
    private dialogRef: MatDialogRef<AlterarValorLiquidoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { contratoId: number },
    private contratoService: ContratoService,
    private dialogService: DialogService
  ) { }
  ngOnInit(): void {
    this.loadSituacoesContrato();
    this.loadContrato();
    const shared = SharedService.getInstance();
    this.usuario = shared.usuario;
  }

  private loadSituacoesContrato(callback?: () => void): void {
    this.contratoService.listarSituacaoContrato()
      .subscribe({
        next: (res: any) => {
          const lista: SituacaoContratoDTO[] = res.object || [];
          this.situacoesContrato = lista.map(s => ({
            label: s.descricao.replace(/_/g, ' '),
            nomeEnum: s.descricao,
            value: s.codigo
          }));
          if (callback) callback();
        },
        error: () => {
          this.dialogService.feedbackError('Erro ao carregar situações de contrato!');
        }
      });
  }

  private loadContrato(): void {
    this.contratoService.findOne(this.data.contratoId)
      .subscribe({
        next: (res: ReturnAPI<Contrato>) => {
          if (res.success && res.object) {
            this.contrato = res.object;
            this.loadSituacoesContrato();
            this.valorLiquidoAtual = this.contrato.valorLiquido;
            this.valorLiquido = this.valorLiquidoAtual;
            this.situacaoContratoSelecionada = this.situacoesContrato.find(s => s.nomeEnum === this.contrato!.situacaoContrato)?.value || null;
            this.dataEmissao = this.contrato.dataEmissao ? new Date(this.contrato.dataEmissao) : null;
            this.dataLiberacao = this.contrato.dataLiberacao ? new Date(this.contrato.dataLiberacao) : null;
            this.dataFinalizacao = this.contrato.dataFinalizacao ? new Date(this.contrato.dataFinalizacao) : null;
            this.dataVencimento = this.contrato.dataVencimento ? new Date(this.contrato.dataVencimento) : null;
            this.dataVencimentoDiasCorridos = this.contrato.dataVencimentoDiasCorridos ? new Date(this.contrato.dataVencimentoDiasCorridos) : null;
            this.nomeFuncionario = this.usuario.nome || null;
          } else {
            this.dialogService.feedbackError(res.messages?.[0]?.text || 'Erro ao carregar contrato!');
          }
          this.carregando = false;
        },
        error: () => {
          this.dialogService.feedbackError('Erro ao carregar contrato!');
          this.carregando = false;
        }
      });
  }

  onChangeData(prop: string, event: any) {
    const value = event.value ? new Date(event.value) : null;
    this[prop] = value;
  }

  salvar(): void {
    if (!this.contrato) return;
    if (!this.valorLiquido || this.valorLiquido <= 0) {
      this.dialogService.feedbackError('Informe um valor válido!');
      return;
    }

    const dto = {
      contratoId: this.data.contratoId,
      valorLiquido: this.valorLiquido,
      situacaoContrato: this.situacaoContratoSelecionada,
      dataEmissao: this.dataEmissao,
      dataLiberacao: this.dataLiberacao,
      dataFinalizacao: this.dataFinalizacao,
      dataVencimento: this.dataVencimento,
      dataVencimentoDiasCorridos: this.dataVencimentoDiasCorridos,
      idFuncionarioHeimdall: this.usuario ? this.usuario.id : null,
      nomeFuncionario: this.nomeFuncionario ? this.usuario.nome : null
    };

    this.contratoService.alterarValorLiquido(dto)
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.dialogService.feedbackSuccess('Contrato atualizado com sucesso!');
            setTimeout(() => this.dialogRef.close(true), 800);
          } else {
            this.dialogService.feedbackError('Erro ao atualizar contrato!');
          }
        },
        error: () => {
          this.dialogService.feedbackError('Erro ao atualizar contrato!');
        }
      });
    this.dialogRef.close();
  }

  fechar(): void {
    this.dialogRef.close();
  }
}
